import { css } from 'lit';
export const passwordChecklistItemStyles = css `
    :host {
        display: block;
    }

    :host-context(hlx-password-checklist-item:last-of-type) .hlx-password-checklist-item {
        margin-bottom: 0;
    }

    .hlx-password-checklist-item {
        display: flex;
        align-items: center;
        margin-bottom: var(--hlx-spacing-sm);
    }

    .hlx-password-checklist-label {
        display: block;
        color: var(--hlx-input-help-text-color);
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-normal);
        line-height: var(--hlx-text-line-height-tight-2);
        margin-left: var(--hlx-spacing-xs);
    }
`;
//# sourceMappingURL=password-checklist-item.styles.js.map